import Phaser from "phaser";
import { CardData, Rank, Suit } from "@ravalmatic/euchre-engine";

const VALUES: Partial<Record<Rank, string>> = { [Rank.JACK]: "J", [Rank.QUEEN]: "Q", [Rank.KING]: "K", [Rank.ACE]: "A" };

// Bridge's card composition and atlas, with Euchre's card data and input contract.
export class Card extends Phaser.GameObjects.Container {
    public static readonly WIDTH = 135;
    public static readonly HEIGHT = 190;

    constructor(scene: Phaser.Scene, card: CardData | null, onSelected?: () => void, dimmed = false) {
        super(scene);
        this.add(new Phaser.GameObjects.Image(
            scene, 0, 0, "texture_atlas_1", card ? "card_background" : "back_card"
        ));
        if (card) {
            const value = VALUES[card.rank] ?? String(card.rank);
            const color = card.suit === Suit.HEARTS || card.suit === Suit.DIAMONDS ? "#D92727" : "#1F252D";
            this.add(new Phaser.GameObjects.Text(scene, -34, -62, value, {
                fontFamily: "Baloo2-SemiBold", fontSize: value === "10" ? "39px" : "44px", color
            }).setOrigin(.5));
            this.add(new Phaser.GameObjects.Image(scene, -34, -28, "texture_atlas_1", `${card.suit}_icon`).setScale(.175));
            this.add(new Phaser.GameObjects.Image(scene, 0, 28, "texture_atlas_1", `${card.suit}_icon`).setScale(.495));
            if (dimmed) {
                this.add(new Phaser.GameObjects.Image(scene, 0, 0, "texture_atlas_1", "card_background_dark_layer"));
            }
        }
        if (onSelected) {
            this.setInteractive({
                hitArea: new Phaser.Geom.Rectangle(-Card.WIDTH / 2, -Card.HEIGHT / 2, Card.WIDTH, Card.HEIGHT),
                hitAreaCallback: Phaser.Geom.Rectangle.Contains, useHandCursor: true
            });
            this.on("pointerover", () => this.setAlpha(.8));
            this.on("pointerout", () => this.setAlpha(1));
            this.on("pointerup", onSelected);
        }
    }
}
